import React, { Component } from 'react';
import lang from '../../../lang/index';
import Mlink from '../../../components/mlink';

export default class SslNavBar extends Component {
    constructor(props){
        super(props);
    }

    render() {
        return (
            <nav className="recharge-nav">
                <div className="nav-top">
                    <div className="expand" onClick={this.props.toggleExpand('expand')}/>
                    <div className="navs" style={{height: this.props.expand ? window.innerHeight : 0}}>
                        <ul>
                            <li>
                                <div className="head">
                                    <div className="text">
                <Mlink href="http://h5.upliveapp.com/zencms/5bd7cb60d107b61703df3e9b.html">{ lang.template('关于我们') }</Mlink>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="head">
                                    <div className="text">
                                        <Mlink href="http://h5.upliveapp.com/zencms/5bd7cb0dd107b61703df3e9a.html">{ lang.template('退款及取消条款') }</Mlink>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="head">
                                    <div className="text">
                                        <Mlink href="http://h5.upliveapp.com/zencms/5bd7cb8bd107b61703df3e9c.html">{ lang.template('联系我们') }</Mlink>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="head">
                                    <div className="text">
                                        <Mlink href="http://h5.upliveapp.com/zencms/5bd7c986d107b61703df3e99.html">{ lang.template('支付条约') }</Mlink>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="head">
                                    <div className="text">
                                        <Mlink href="http://h5.upliveapp.com/zencms/5bd7ccf5d107b61703df3e9d.html">{ lang.template('个人隐私条款') }</Mlink>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}



// WEBPACK FOOTER //
// ./js/orderview/channels/ssl/navbar.js